export function convertFilterValuesToAppliedFilters(
  filterValues: Record<string, string[]>
) {
  return Object.entries(filterValues)
    .filter((item): item is [string, string[]] => item[1].length > 0)
    .map(([attributeId, values]) => {
      return {
        attribute_id: attributeId,
        values: values
      }
    })
}
